"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Partly = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Partly = function Partly(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12c-3.86 0-7 3.14-7 7s3.14 7 7 7h9.5c2.481 0 4.5-2.019 4.5-4.5S21.981 17 19.5 17a4.51 4.51 0 00-1.599.298l-.96.366-.339-.971A7.004 7.004 0 0010 12zm9.5 16H10c-4.962 0-9-4.038-9-9s4.038-9 9-9a9.006 9.006 0 018.127 5.149A6.422 6.422 0 0119.5 15c3.584 0 6.5 2.916 6.5 6.5S23.084 28 19.5 28z",
    fill: "#D0D6E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.632 10.046a8.966 8.966 0 011.723.28.997.997 0 00-.012-1.397l-2.121-2.121a.999.999 0 10-1.414 1.414l1.824 1.824zM30 15h-3a1 1 0 000 2h3a1 1 0 000-2zm-4.085 7.501a6.426 6.426 0 01-.713 2.115l.576.576a.997.997 0 001.415 0 1 1 0 000-1.414l-1.278-1.277zm-1.551-11.865a.993.993 0 00.707-.293l2.122-2.121a1 1 0 00-1.415-1.414l-2.121 2.12a.999.999 0 00.707 1.708zM18 8a1 1 0 001-1V4a1 1 0 00-2 0v3a1 1 0 001 1zm0 1.5c3.584 0 6.5 2.916 6.5 6.5 0 .418-.041.827-.118 1.222a6.557 6.557 0 00-1.91-1.496C22.328 13.374 20.388 11.5 18 11.5c-.812 0-1.564.233-2.221.614a9.033 9.033 0 00-1.826-1.179A6.444 6.444 0 0118 9.5z",
    fill: "#FF991F"
  }));
};

exports.Partly = Partly;
var _default = Partly;
exports.default = _default;